import React, { Fragment } from 'react';
import {Button} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';

class MyModal extends AbstractComponent {        
    fechar() {                
        if(this.props.fechar !== undefined) {
            this.props.fechar();
        }
    }    

    styleList(i) {
        if(i === 0)
            return {
                marginBottom: '25px',
                fontWeight: '700'
            };

        return {listStyle: 'circle'}
    }

    texto() {                
        if(Array.isArray(this.props.texto))
            return (
                <ul>
                    {this.props.texto.map((item, i) => {
                        return (
                            <li 
                                style={this.styleList(i)}
                                key={i}
                            >
                                {item}
                            </li>
                        )
                    })}
                </ul>
            );
        
        const texto = (this.props.texto === undefined) ? '' : this.props.texto;

        return (texto === undefined || texto === '' || texto ===  null) ? this.P_ERRO_PADRAO() : texto;                      
    } 
    
    subTexto() {            
        return this.props.subTexto === undefined ? '' : this.props.subTexto;                      
    }     

    styleHeader() {                
        return (this.props.styleHeader === undefined) ? "bg-white" : this.props.styleHeader;
    }

    styleIcon() {
        return (this.props.styleIcon === undefined) ? "" : this.props.styleIcon;
    }

    styleText() {
        return (this.props.styleText === undefined) ? "text-dark" : this.props.styleText;        
    }

    styleButton() {
        return (this.props.styleButton === undefined) ? "btn-primary" : this.props.styleButton;        
    }

    styleCloseButton() {
        if(this.props.styleCloseButton === undefined)
            return '';

        return this.props.styleCloseButton;        
    }

    show() {
        if(!this.props.show)
            return ;

        return (
            <div 
                className={"modal " + this.className} 
                tabIndex="-1" 
                role="dialog" 
                style={{display: 'block'}}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {
                            this.props.header !== "" &&
                            <div className={"modal-header " + this.styleHeader()}>
                                <div className="col-md-10                                 
                                                col-sm-10                                                
                                                col-lg-10                                                
                                                col-xs-10"> 
                                    <h4>
                                        {
                                            this.props.styleIcon !== undefined &&
                                            <Fragment>
                                                <i className={this.styleIcon()}/>
                                                &nbsp;
                                                &nbsp;
                                                &nbsp;
                                            </Fragment>
                                        }
                                        
                                        {this.props.header}
                                    </h4>
                                </div>

                                <div className="col-md-2                                 
                                                col-sm-2                                                
                                                col-lg-2                                                
                                                col-xs-2"> 
                                    <button type="button" className={"close " + this.styleCloseButton()} data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        }

                        <div className="modal-body">
                            <div 
                                className={this.styleText()} 
                                style={{
                                    wordWrap: 'break-word', 
                                    marginBottom: '15px'
                                }}>

                                {this.texto()}

                                <br/>
                                <br/>

                                {this.subTexto()}                        
                            </div>
                        </div>

                        <div className="modal-footer">
                            <Button 
                                className={"btn " + this.styleButton()}  
                                type="button" 
                                onClick={() => {this.fechar()}}
                            >
                                {this.props.buttonTxt}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <Fragment>
                {this.show()}            
            </Fragment>
        )
    }
}

MyModal.defaultProps = {
    textoArray: []
}

export default MyModal;